<script>
import * as echarts from 'echarts';
import InnerLoading from '@/components/spinner/spinner.vue';
import {branchInfoList3, salesmanage_salesinfo_siteSales} from "@/lib/request";
import {optionLine, optionPie} from '@/untils/option'
export default {
  name:'techSiteIdInfo',
  data(){
    return{
      innerLoading:false,
      startPoint:{
        lng: null,
        lat: null
      },
      endPoint:{
        lng: null,
        lat: null
      },
      siteItem:{},
      userItem:{},
      staffList:[],
      tabCurrent:1,
      tabName:[
        {type:0,name:'月度',classStr:'blue'},
        {type:1,name:'年度',classStr:'purple'},
      ],
      valueMonth: '',
      columnsIndex:0,
      columns: [],
      showPicker: false,
      basicSales:{},
      tabTitleName:[
        {type:0,name:'电脑票明细',classStr:'blue'},
        {type:1,name:'即开票总计',classStr:'purple'},
      ],
      tabTitleCurrent:0,
      currentYeasComputerBeans:[],
      currentYeasInstantTicketBeans:[],
    }
  },
  components:{
    InnerLoading
  },
  watch:{
    searchParams(newVal, oldVal) {
      console.log(newVal, oldVal)
      this.getInData();
    },
  },
  computed:{
    // 监控参数变化
    searchParams() {
      return {
        siteId:this.siteItem.branchId,
        queryType:this.tabCurrent,
        month:this.valueMonth
      }
    },
  },
  methods:{
    // 查询
    getSiteIdInfo(siteId){
      branchInfoList3({
        pageNum:1,
        pageSize:10,
        branchId:siteId
      }).then((res) => {
        if (res) {
          if (res.data) {
            if (res.data.code === 200) {
              if(res.data.rows&&res.data.rows.length>0){
                this.siteItem = res.data.rows[0];
                this.userItem = res.data.rows[0].agentInfo;
                if(res.data.rows[0].latitude&&res.data.rows[0].longitude){
                  this.endPoint={
                    lat: res.data.rows[0].latitude,
                    lng: res.data.rows[0].longitude,
                  }
                }
                let arr = []
                res.data.rows[0].salespersonInfos.map((v)=>{
                  if(v.reviewStatus===1){
                    arr.push(v)
                  }
                });
                this.staffList = arr;
                // this.getInData();
              }else{
                this.$toast(`暂无${siteId}站点数据，请检查站点是否正确！`);
              }
            }else{
              this.$toast.fail(res.data.msg);
            }
            this.innerLoading = false;
          }
        }
      });
    },
    getTabLab(item){
      this.tabCurrent = item.type;
      if(item.type===0){
        this.columnsIndex = this.columns.length-1;
        this.valueMonth = this.columns[this.columns.length-1];
      }
    },
    getTitleTabLab(item){
      this.tabTitleCurrent = item.type;
      // 切换到折线图时，如果数据存在则初始化
      if (item.type === 1) {
        this.$nextTick(() => {
          // 准备折线图数据
          let month = [];
          let numArr = [];
          this.currentYeasInstantTicketBeans.forEach((v)=>{
            month.push(v.month+'月');
            numArr.push(v.salse);
          });

          if (month.length > 0) {
            this.initChartLine(month, numArr);
          }
        });
      }
    },
    onConfirm(value) {
      this.valueMonth = value;
      this.showPicker = false;
    },
    getInData(){
      this.basicSales = {}
      salesmanage_salesinfo_siteSales(this.searchParams).then((res)=>{
        if(res){
          if(res.data.code===200){
            this.basicSales = res.data.data.basicSales;
            res.data.data.currentYeasComputerBeans.map((v,index)=>{
              if(index===0){
                v.styleStr = 'icon_top0'
              }else if(index===1){
                v.styleStr = 'icon_top1'
              }else if(index===2){
                v.styleStr = 'icon_top2'
              }else if(index===3){
                v.styleStr = 'icon_top3'
              }else if(index===4){
                v.styleStr = 'icon_top4'
              }
            })
            this.currentYeasComputerBeans = res.data.data.currentYeasComputerBeans;
            this.currentYeasInstantTicketBeans = res.data.data.currentYeasInstantTicketBeans;
            this.$nextTick(() => {
              this.initChart();
            });
          }else{
            this.$toast(res.data.msg);
            return false;
          }
        }
      })
    },
    initChartLine(month, numArr){
      this.$nextTick(() => {
        const chartLineDom = this.$refs.chartLine;
        if (!chartLineDom) return;

        // 检查容器是否可见
        if (chartLineDom.clientWidth === 0 || chartLineDom.clientHeight === 0) {
          // 如果容器不可见（比如被隐藏），延迟重试
          setTimeout(() => {
            this.initChartLine(month, numArr);
          }, 100);
          return;
        }

        // 先销毁已有实例
        let existingChart = echarts.getInstanceByDom(chartLineDom);
        if (existingChart) {
          existingChart.dispose();
        }

        const chartLine = echarts.init(chartLineDom);
        const option = JSON.parse(JSON.stringify(optionLine)); // 深拷贝避免引用问题
        option.xAxis.data = month;
        option.series[0].data = numArr;
        chartLine.setOption(option);
        chartLine.resize();
      });
    },

    initChart(){
      const chartDom = this.$refs.pieCharts;
      if (!chartDom) return;

      if (chartDom.clientWidth === 0 || chartDom.clientHeight === 0) {
        setTimeout(() => {
          this.initChart();
        }, 100);
        return;
      }

      // 先销毁已有实例
      let existingChart = echarts.getInstanceByDom(chartDom);
      if (existingChart) {
        existingChart.dispose();
      }

      const chartInstance = echarts.init(chartDom);
      optionPie.series[0].data[0].value = this.basicSales.computicketsSales || 0;
      optionPie.series[0].data[1].value = this.basicSales.instantGamesSales || 0;
      chartInstance.setOption(optionPie);

      // 准备折线图数据
      let month = [];
      let monthStr = [];
      let numArr = [];
      this.currentYeasInstantTicketBeans.forEach((v)=>{
        month.push(v.month+'月');
        monthStr.push(v.month);
        numArr.push(v.salse);
      });
      let date = new Date();
      let years = date.getFullYear();
      this.columns = monthStr.map(item => `${years}-${item.padStart(2, '0')}`);
      // 如果当前显示的是折线图，则初始化
      if (this.tabTitleCurrent === 1) {
        this.initChartLine(month, numArr);
      }
    }
  },
  created(){
    let siteId = this.$route.query.siteId;
    if(siteId){
      this.innerLoading = true;
      // 查询网点信息
      this.getSiteIdInfo(siteId);
    }
  },
  mounted() {
  }
}
</script>
<template>
  <div class="content">
    <inner-loading v-model="innerLoading"></inner-loading>
    <div class="card" v-if="siteItem&&siteItem.branchId">
      <div class="card-title">
        网点{{siteItem.branchId}}
        <div class="">
          <span class="green" v-if="siteItem.businessStatus===1">正常营业</span>
          <span class="reds" v-else-if="siteItem.businessStatus===2">暂停营业</span>
          <span class="" v-else>无营业状态</span>
        </div>
      </div>
      <div class="gird-horizon-card">
        <div class="info-item-horizon">
          <div class="gird-horizon">
            <div class="label-icon"><van-icon name="location-o" /></div>
            <div class="gird-vertical">
              <div class="info-label">所在地区</div>
              <div class="info-value">{{siteItem.district}}</div>
            </div>
          </div>
        </div>
        <div class="info-item-horizon">
          <div class="gird-horizon">
            <div class="label-icon"><van-icon name="location-o" /></div>
            <div class="gird-vertical">
              <div class="info-label">所属区域</div>
              <div class="info-value">{{siteItem.city}}{{siteItem.area?'-'+siteItem.area:siteItem.area}}</div>
            </div>
          </div>
        </div>
        <div class="info-item-horizon">
          <div class="gird-horizon">
            <div class="label-icon"><van-icon name="shop-o" /></div>
            <div class="gird-vertical">
              <div class="info-label">经营类型</div>
              <div class="info-value">{{ userItem.branchType==='1'?'福彩':'福体' }}{{ userItem.businessType==='1'?'专营':'兼营' }}</div>
            </div>
          </div>
        </div>
        <div class="info-item-horizon" v-if="siteItem.storeType">
          <div class="gird-horizon">
            <div class="label-icon"><van-icon name="birthday-cake-o" /></div>
            <div class="gird-vertical">
              <div class="info-label">店面类型</div>
              <div class="info-value">{{ siteItem.storeType }}</div>
            </div>
          </div>
        </div>
        <div class="info-item-horizon" v-if="siteItem.years">
          <div class="gird-horizon">
            <div class="label-icon"><van-icon name="notes-o" /></div>
            <div class="gird-vertical">
              <div class="info-label">经营年限</div>
              <div class="info-value">{{siteItem.years}}</div>
            </div>
          </div>
        </div>
        <div class="info-item-horizon" v-if="userItem.agentName">
          <div class="gird-horizon">
            <div class="label-icon"><van-icon name="user-o" /></div>
            <div class="gird-vertical">
              <div class="info-label">代销者姓名</div>
              <div class="info-value">
                {{ userItem.agentName }}
                <a :href="`tel:${userItem.contact}`" style="display: flex"><van-icon class="phone-green" v-if="userItem.contact" name="phone-o" /></a>
                <span style="display: none">{{ userItem.contact|phoneHideValue }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="info-item-horizon">
          <div class="gird-horizon">
            <div class="label-icon"><van-icon name="location-o" /></div>
            <div class="gird-vertical">
              <div class="info-label">详细地址</div>
              <div class="info-value">{{siteItem.address}}</div>
            </div>
          </div>
        </div>
        <div class="info-item-horizon">
          <div class="gird-horizon">
            <div class="label-icon"><van-icon name="send-gift-o" /></div>
            <div class="gird-vertical">
              <div class="info-label">培训状态</div>
              <div class="info-value">
                <span class="gray" v-if="siteItem.trainingStatus===0">未培训</span>
                <span class="gray" v-else-if="siteItem.trainingStatus===1">已培训</span>
                <span class="" v-else>无</span>
              </div>
            </div>
          </div>
        </div>
        <div class="info-item-horizon" v-for="(item,index) in staffList" :key="index" v-show="item.reviewStatus===1">
          <div class="gird-horizon">
            <div class="label-icon"><van-icon name="friends-o" /></div>
            <div class="gird-vertical">
              <div class="info-label">销售员</div>
              <div class="info-value">
                {{ item.name }}
                <a :href="`tel:${userItem.contact}`" style="display: flex">
                  <van-icon class="phone-green" v-if="item.contact" name="phone-o" />
                </a>
                <span style="display: none">{{ item.contact|phoneHideValue }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-title">
        总销量统计
        <div class="lab-tab">
          <div class="lab-item" v-for="(item,index) in tabName" :class="[item.classStr,tabCurrent===item.type?'':'fontD']" :key="index" @click="getTabLab(item)">
            <div >{{item.name}}</div>
          </div>
        </div>
      </div>
      <div class="select-box" v-if="this.tabCurrent===0">
        <div class="select-item"  :class="tabCurrent===0?'back-blue':'back-purple'" @click="showPicker = true">
          {{valueMonth}}<van-icon name="arrow-down" />
        </div>
      </div>
      <div class="card-number-row" :class="tabCurrent===0?'back-blue':'back-purple'">
        <div class="card-flex-colum">
          <div class="title-colum">总销量</div>
          <div class="text-colum" :class="tabCurrent===0?'color-blue':'color-purple'">￥{{basicSales.summarySales | formatNumberData}}</div>
        </div>
        <div class="card-flex-colum">
          <div class="title-colum">总排名</div>
          <div class="text-colum" :class="tabCurrent===0?'color-blue':'color-purple'">#{{basicSales.ranking}}</div>
        </div>
      </div>
      <div class="card back">
        <div style="width: 100%;height: 250px;" ref="pieCharts"></div>
        <div class="back-row">
          <div class="back-row-colum blue-bor">
            <div class="gray-color"><span class="blue-back"></span>电脑票</div>
            <div class="blue-font">￥{{basicSales.computicketsSales|formatNumberData}}</div>
            <div class="gray-color">{{(basicSales.computerProportion*100).toFixed(2)}}%</div>
          </div>
          <div class="back-row-colum orange-bor">
            <div class="gray-color"><span class="orange-back"></span>即开票</div>
            <div class="orange-font">￥{{basicSales.instantGamesSales|formatNumberData}}</div>
            <div class="gray-color">{{(basicSales.immediateProportion*100).toFixed(2)}}%</div>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="entitle-lab-tab">
        <div class="entitle-lab-item" v-for="(item,index) in tabTitleName" :class="[item.classStr,tabTitleCurrent===item.type?'':'fontD']" :key="index" @click="getTitleTabLab(item)">
          <div >{{item.name}}</div>
        </div>
      </div>
      <div>
        <div class="list-colum" v-show="tabTitleCurrent===0">
          <div class="list-row" v-for="(item,index) in currentYeasComputerBeans" :key="index">
            <div class="item-row-name"><span class="ball" :class="item.styleStr">{{index+1}}</span>{{item.gameName}}</div>
            <div class="item-row-num">{{item.salse|formatNumberData}}</div>
          </div>
        </div>
        <div v-show="tabTitleCurrent===1" style="width: 100%;height: 250px">
          <div style="width: 100%;height: 250px" ref="chartLine"></div>
        </div>
      </div>
    </div>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
          show-toolbar
          :defaultIndex="columnsIndex"
          value-key="text"
          :columns="columns"
          @confirm="onConfirm"
          @cancel="showPicker = false"
      />
    </van-popup>
  </div>
</template>
<style scoped lang="scss">
.content{
  padding-top: 120px;
  box-sizing: border-box;
  .guide-btn{
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap:20px;
  }
  .map-view{
    width: 100%;
    height: 400px;
    border: 2px solid #ddd;
  }
}
.back{
  margin-top: 20px;
  background: oklch(98.5% .002 247.839)
}
.color-blue{
  color:  oklch(54.6% .245 262.881);
}
.color-purple{
  color: oklch(55.8% .288 302.321);
}
.back-blue{
  background: oklch(97% .014 254.604);
  border: 1px solid oklch(93.2% .032 255.585);
}
.back-purple{
  background: oklch(97.7% .014 308.299);
  border: 1px solid oklch(94.6% .033 307.174);

}
.select-box{


  margin-bottom: 20px;
  .select-item{
    display: flex;
    justify-content: space-between;
    border: 1px solid #ddd;
    border-radius: 10px;
    padding: 20px 20px;
  }
}
.list-colum{
  padding: 20px 0;
}
.list-row{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 20px 20px 20px 20px;
  border-radius: 20px;
  background: oklch(97% .014 254.604);
  margin-top: 20px;
  border: 1px solid oklch(93.2% .032 255.585);
  .item-row-name{
    color: #333;
    .ball{
      display: inline-block;
      width: 48px;
      height: 48px;
      line-height: 48px;
      text-align: center;
      //background: oklch(68.1% .162 75.834);
      border-radius: 50% 50%;
      margin-right: 20px;
      color: #fff;
    }
    .icon_top0{
      background: radial-gradient(circle,oklch(85.2% .199 91.936),oklch(68.1% .162 75.834));
    }
    .icon_top1 {
      background: radial-gradient(circle, oklch(70.7% .022 261.325), oklch(44.6% .03 256.802));
    }
    .icon_top2 {
      background: radial-gradient(circle, oklch(75% .183 55.934), oklch(64.6% .222 41.116));
    }
    .icon_top3 {
      background: radial-gradient(circle, oklch(92.8% .006 264.531), oklch(92.8% .006 264.531));
    }
    .icon_top4 {
      background: radial-gradient(circle, red, yellow);
    }
  }
  .item-row-num{
    color: oklch(54.6% .245 262.881);
    font-weight: bold;
  }
}
.back-row{
  display: grid;
  grid-template-columns: 1fr 1fr ;
  gap: 20px;
  .back-row-colum{
    padding: 20px;
    border-radius: 20px;
    background: #fff;

  }
  .blue-bor{
    border: 1px solid oklch(88.2% .059 254.128);
  }
  .orange-bor{
    border: 1px solid oklch(90.1% .076 70.697);
  }
  .blue-font{
    font-weight: bold;
    font-size: 30px;
    color: oklch(54.6% .245 262.881);
  }
  .orange-font{
    font-weight: bold;
    font-size: 30px;
    color: oklch(64.6% .222 41.116);
  }
  .gray-color{
    color: oklch(55.1% .027 264.364);
  }
  .blue-back{
    display: inline-block;
    height: 20px;
    width: 20px;
    border-radius: 50% 50%;
    background: oklch(62.3% .214 259.815);
    margin-right: 10px;
  }
  .orange-back{
    display: inline-block;
    height: 20px;
    width: 20px;
    border-radius: 50% 50%;
    background: oklch(70.5% .213 47.604);
    margin-right: 10px;
  }
}
.card-number-row{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 20px;
  border-radius: 20px;
  .card-flex-colum{
    display: flex;
    flex-direction: column;

    .title-colum{
      display: flex;
      color: oklch(55.1% .027 264.364);
      font-size: 22px;
    }
    .text-colum{
      display: flex;
      justify-content: flex-end;
      font-size: 38px;
      font-weight: bold;
    }
  }
}
.card-title{
  padding-bottom: 20px;
  border-bottom: 1px solid #ddd;
  .lab-tab{
    display: flex;
    flex-direction: row;
    border-radius: 30px;
    width: 200px;
    background: oklch(96.7% .003 264.542);
    .lab-item{
      width: 100px;
      border-radius: 30px;
      padding:5px 10px;
      text-align: center;
      font-weight: normal;
    }
    .blue{
      color: #fff;
      background: oklch(54.6% .245 262.881);
    }
    .purple{
      color: #fff;
      background: oklch(55.8% .288 302.321);
    }
    .fontD{
      color: #333;
      background: transparent;
    }
  }
}
.entitle-lab-tab{
  display: flex;
  flex-direction: row;
  border-radius: 30px;
  width: 100%;
  background: oklch(96.7% .003 264.542);
  .entitle-lab-item{
    width: 50%;
    border-radius: 50px;
    padding:15px 10px;
    text-align: center;
    font-weight: normal;
  }
  .blue{
    color: #fff;
    background: oklch(54.6% .245 262.881);
  }
  .purple{
    color: #fff;
    background: oklch(64.6% .222 41.116);
  }
  .fontD{
    color: #333;
    background: transparent;
  }
}
.gird-horizon-card{
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 28px;
  padding: 0 10px;
}
.info-item-horizon{
  display: flex;
  flex-direction: column;
  .gird-horizon{
    display: flex;
    flex-direction: row;
  }
}
.label-icon{
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 10px;
  color: oklch(70.7% .022 261.325);
  font-size: 40px;
}
.info-label{
  color: oklch(70.7% .022 261.325);
  font-size: 24px;

}
.info-value{
  font-weight: bold;
  display: flex;
  align-items: center;
}
.gird-vertical{
  display: flex;
  flex-direction: column;
}
.phone-green{
  font-size: 34px;
  color: oklch(62.7% .194 149.214);
  padding-left: 10px;
}
.gray{
  border: 1px solid #ddd;
  border-radius: 20px;
  font-size: 25px;
  padding: 5px 14px;
}
.green{
  background: oklch(72.3% .219 149.579);
  color: #fff;
  font-size: 25px;
  border-radius: 30px;
  padding: 8px 18px;
  font-weight: normal;
}
.red{
  background: oklch(57.7% .245 27.325);
  color: #fff;
  font-size: 25px;
  border-radius: 30px;
  padding: 8px 18px;
  font-weight: normal;
}
</style>